export enum EventTemplateLayout {
  ONE_COLUMN = 'ONE_COLUMN',
  ONE_COLUMN_ELEGANT = 'ONE_COLUMN_ELEGANT',
  ONE_COLUMN_MODERN = 'ONE_COLUMN_MODERN',
  TWO_COLUMNS = 'TWO_COLUMNS',

  // used for standard and premium events
  IMAGE_LEFT = 'IMAGE_LEFT',
  IMAGE_RIGHT = 'IMAGE_RIGHT',
}
